import { Component } from '@angular/core'

@Component({
  templateUrl: 'home.com.html',
  styleUrls: ['home.scss']
})

export class HomeComponent {}



// WEBPACK FOOTER //
// ./src/app/com/home/home.com.ts